// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { forceSend } = require('utilities/tagging.js')
// @utilities
const { APIGet  } = require('utilities/APIRequestHelper');

const getEncryptedIP = () => () => {
    APIGet(() => {}, apiURLBuilder.getURL('getEncryptedIP'))
        .then((x) => {
            window.utag_ip = x.encryptedMessage;
            forceSend();
        })
        .catch(() => {
            window.utag_ip = "ERROR IP";
        });
}

module.exports = {
    getEncryptedIP
}
